export const MARKREADNOTIFICATION = "MARKREADNOTIFICATION"
export const DELETE_USER_TOKEN = "DELETE_USER_TOKEN"

export const markReadNotification = (data,op) => {
    return {
      type: MARKREADNOTIFICATION,
      payload:data,
      optype:op
    };
  };

  export const DeleteUserToken = (data) => {
    return {
      type: DELETE_USER_TOKEN,
      payload:data
    };
  };
